import React from "react";
import DefaultQuestionBody from "./DefaultQuestionBody";

const OrgFinderComponent = () => <DefaultQuestionBody />;

OrgFinderComponent.information = {
	type: "select",
	cayuseType: "org-finder",
	name: "External Org Finder",
};

OrgFinderComponent.extraSettings = {
	tagsEnabled: false,
	preselectAll: false,
	enableAutocomplete: true,
	autocompleteMinLength: 1,
	dataSource: "Rest",
	queryUrl: "{{endpoints.cayuse}}/organization?search={{$searchText}}",
	lookupUrl: "{{endpoints.cayuse}}/organization/{{$id}}",
	linkTargetView: "browse",
	formatItem: "{{$item.name}}",
	storage: "Id",
	identity: "id",
	linkTarget: "_blank",
	multi: false
};

OrgFinderComponent.customOptions = [
	{
		label: "User can select multiple orgs",
		type: "multi"
	}
];

export default OrgFinderComponent;
